// Static media configuration for videos placed in public/videos folder
export const STATIC_VIDEOS = {
  hero: {
    video: '/videos/demo_generale.mov',
    poster: null,
  },
  valueProps: [
    {
      id: 'demo-chat',
      type: 'video' as const,
      src: '/videos/demo_chat.mov',
      title: 'Demo Chat',
      label: 'Chat AI',
      description: 'Interfaccia conversazionale intelligente per studenti e docenti',
    },
    {
      id: 'demo-contenuti',
      type: 'video' as const,
      src: '/videos/demo_generazione_contenuti.mov',
      title: 'Generazione Contenuti',
      label: 'Contenuti',
      description: 'Creazione automatica di materiale didattico personalizzato',
    },
    {
      id: 'demo-modelli-3d',
      type: 'video' as const,
      src: '/videos/demo_generazione_modelli3d.mov',
      title: 'Generazione Modelli 3D',
      label: 'Modelli 3D',
      description: 'Generazione AI di oggetti 3D per l\'apprendimento visivo',
    },
    {
      id: 'demo-caricamento',
      type: 'video' as const,
      src: '/videos/demo_caricamento_modelli3d.mov',
      title: 'Gestione Modelli 3D',
      label: 'Gestione 3D',
      description: 'Upload e gestione di modelli tridimensionali nella piattaforma',
    },
  ],
} as const;
